module.exports = __webpack_public_path__ + "img/cy.614f52cc.svg";